import Vue from 'vue'

// 引入ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 引入display.css
import 'element-ui/lib/theme-chalk/display.css';
// 引入animate.css
import 'animate.css';

// 引入animate.css
import '@/static/weather.css';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import './static/quillEditor.css'

import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'


// 使用ElementUI
Vue.use(ElementUI);


Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
